import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { ArrowDirection, ArrowIconWithMargin } from '@lean-body/components/atoms';
import { Colors } from '@lean-body/components/styles';
import { dailyLessonVolumeSolidColor } from '@lean-body/src/domain/daily_lesson_volume_colors';
export const HomeDailyLessonVolumeChip = ({ volumeNumber, volumeColor, onClick, classObject }) => {
    const volumeChipStyle = VOLUME_CHIP_STYLES[volumeColor];
    const isClickable = onClick != null;
    return (React.createElement("div", { className: css(styles.volumeChip, volumeChipStyle, isClickable && styles.volumeChipClickable, classObject), onClick: onClick },
        React.createElement("span", { className: css(styles.volumeChipLabel) }, `Vol.${volumeNumber}`),
        React.createElement(ArrowIconWithMargin, { direction: ArrowDirection.right, color: Colors.White, classObject: styles.volumeChipArrow })));
};
const styles = StyleSheet.create({
    volumeChip: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 8,
        padding: '6px 6px 6px 14px',
        borderRadius: 6,
        whiteSpace: 'nowrap',
    },
    volumeChipClickable: {
        cursor: 'pointer',
    },
    volumeChipGreen: {
        backgroundColor: dailyLessonVolumeSolidColor('green'),
    },
    volumeChipPink: {
        backgroundColor: dailyLessonVolumeSolidColor('pink'),
    },
    volumeChipYellow: {
        backgroundColor: dailyLessonVolumeSolidColor('yellow'),
    },
    volumeChipBlue: {
        backgroundColor: dailyLessonVolumeSolidColor('blue'),
    },
    volumeChipLabel: {
        fontSize: 16,
        lineHeight: 1,
        color: Colors.White,
    },
    volumeChipArrow: {
        width: 17,
        height: 17,
    },
});
const VOLUME_CHIP_STYLES = {
    green: styles.volumeChipGreen,
    pink: styles.volumeChipPink,
    yellow: styles.volumeChipYellow,
    blue: styles.volumeChipBlue,
};
